import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import M from 'materialize-css/dist/js/materialize';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import BackButton from '../../../../../components/UI/BackButton';
import SelectItem from '../../../../../components/UI/SelectItem';
import ConfirmModal from '../../../../../components/UI/ConfirmModal';
import LinePickingService from '../../../../../services/LinePickingService';
import { ENUMS } from '../../../../../utils/constants';
import { enumText, isNullOrEmpty, translate, showMessageToastCustom } from '../../../../../utils/util';

const ListItemOrderDetail = (props) => {
    const [user, setUser] = useState('fiatauto\\');
    const [cancelGroup, setCancelGroup] = useState(false);

    useEffect(() => {
        document.addEventListener('message', msgHandler);
        M.updateTextFields();
        return () => {
            document.removeEventListener('message', msgHandler);
        };
        // eslint-disable-next-line
    }, []);

    const submit = (changeGroup) => {
        let existeNaLista = props?.usersFromElog.find(x => x.id === user);

        if (user === undefined || user === '' || existeNaLista === undefined) {
            showMessageToastCustom(translate('general:warning'),
                translate('validations:invalid-user'),
                3000, 'mdi mdi-alert-circle-outline red-text');

            return;
        }

        if (!isNullOrEmpty(user.replace("fiatauto\\", ""))) {
            props.changeUserOrder(props.order.orderId, user, changeGroup, () => {
                props.history.goBack();
            });
        }
    }

    const cancel = () => {
        props.history.goBack();
    }

    const openModal = () => {
        const modal = M.Modal.init(document.getElementById('confirmUser'));
        modal.open();
    }

    const showMessageModal = () => {
        if (props.order?.orderGroupId > 0) {
            setCancelGroup(true);
            openModal();
        }
        else {
            submit(false);
        }
    }

    const onConfirmModal = () => {
        submit(cancelGroup)
    };

    const onCancelModal = () => {
        submit(cancelGroup ? false : true);
    }

    const getStatus = (value) => translate(enumText(ENUMS.eOrderStatus, value), 'expedition');

    const msgHandler = (e) => {
        const content = window.ReactNativeWebView;
        content.postMessage('');

        const value = e.data;
        if (value.length >= 3) {
            setUser(value);
        }
    }

    const scanner = () => {
        if (navigator.userAgent === 'logisticspwa') {
            const content = window.ReactNativeWebView;
            content.postMessage('exibirTela');
        } else {
            showMessageToastCustom(translate('general:warning'), translate('validations:service-not-available'), 3000, 'mdi mdi-alert-circle-outline red-text');
        }
    }

    const onChangeData = (value) => {
        if (!isNullOrEmpty(value)) {
            setUser(value);
        }
    };

    const onChangeSelectItem = (value) => {
        setUser(value);
    };

    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65">
                <div className="row">
                    <div className="title">
                        <i className="mdi mdi-camera-timer" />
                        {translate('line-picking:linepicking.title')}
                    </div>
                    <div className="subtitle">
                        | <i className="material-icons">contacts</i>
                        {translate('line-picking:linepicking.operator')}
                    </div>
                </div>
            </div>
            <div className="container" style={{ marginTop: '40px', }}>
                <div className="card">
                    <div className="card-content" style={{ padding: '10px' }}>
                        <form>
                            <div className="row" style={{ marginBottom: '0' }}>
                                <div className="input-field no-padding col s12">
                                    <span className="field f-1p5r">{props.order?.orderCode || ''}</span>
                                    <label className="active" htmlFor="productId">{translate('expedition:picking.orderCode')}</label>
                                </div>
                                <div className="input-field no-padding col s12">
                                    <span className="field f-1r truncate">{props.order?.route?.code || ''}</span>
                                    <label className="active" htmlFor="pn">{translate('line-picking:linepicking.route')}</label>
                                </div>
                                <div className="input-field no-padding col s12">
                                    <span className="field f-1r truncate">{getStatus(props.order?.status || '')}</span>
                                    <label className="active" htmlFor="status">{translate('general:status')}</label>
                                </div>
                                <div className="input-field no-padding col s12">
                                    <i className="mdi mdi-qrcode posfix" onClick={() => scanner()} />
                                    <SelectItem
                                        required
                                        id="username"
                                        name="model.userName"
                                        label={translate('expedition:picking.new-userName')}
                                        onChange={(event) => onChangeSelectItem(event)}
                                        onChangeData={onChangeData}
                                        data={props.usersFromElog ? props.usersFromElog.map(item => {
                                            return {
                                                id: item.id,
                                                text: item.user
                                            }
                                        }) : []}
                                    />
                                </div>
                            </div>
                            <div className="card-action row center" style={{ padding: '1rem 0', marginBottom: '0' }}>
                                <button
                                    type="button"
                                    onClick={cancel}
                                    className="col s6
                                    btn
                                    waves-effect
                                    waves-light
                                    btn-flat"
                                >
                                    {translate('general:cancel')}
                                </button>
                                <button
                                    type="button"
                                    className="col s6
                                    btn
                                    btn-principal
                                    waves-effect
                                    waves-light"
                                    onClick={showMessageModal}
                                >
                                    {translate('general:confirm')}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <ConfirmModal
                id="confirmUser"
                data={{ title: translate('validations:attention'), message: translate('line-picking:messages.all-orders-change-confirmation') }}
                onConfirm={onCancelModal}
                onCancel={onConfirmModal}
                btnCancel= {translate('line-picking:linepicking.all')}
                btnConfirm= {translate('line-picking:linepicking.only-this')}
            />
        </div>
    );
}

const getListSelectUser = (usersElog) => {
    let users = [];
    usersElog.forEach(item => {
        users.push({
            id: item.userName,
            user: item.userName,
        });
    });

    usersElog.forEach(item => {
        users.push({
            id: item.userName,
            user: item.name,
        });
    });

    return users;
}

const mapStateToProps = (state) => {
    return {
        order: state.linePickingReducer.order,
        usersFromElog: getListSelectUser(state.usersElogReducer.usersElog)
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeUserOrder: (orderId, newUser, changeGroup, callback) => {
            dispatch(LinePickingService.changeUserOrder(orderId, newUser, changeGroup, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ListItemOrderDetail)));
